import React, {
  createContext,
  useContext,
  useState,
  useMemo,
  ReactNode,
} from "react";
import { FormValues } from "../../Interface/scheduler/form";

interface FormContextType {
  formValues: FormValues;
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>;
  isGlobalSkeletonLoading?: boolean;
  setIsGlobalSkeletonLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormContext = createContext<FormContextType | undefined>(
  undefined
);

export const FormProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [formValues, setFormValues] = useState<FormValues>({});
  const [isGlobalSkeletonLoading, setIsGlobalSkeletonLoading] = useState(false);
  const contextValue = useMemo(
    () => ({
      formValues,
      setFormValues,
      isGlobalSkeletonLoading,
      setIsGlobalSkeletonLoading,
    }),
    [
      formValues,
      setFormValues,
      isGlobalSkeletonLoading,
      setIsGlobalSkeletonLoading,
    ]
  );
  return (
    <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>
  );
};

export const useFormContext = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useFormContext must be used within a FormProvider");
  }
  return context;
};
